import * as React from 'react';
import {IngredientObject} from 'api/ingredient/types';
import {getIngredientByID} from 'api/ingredient/requests';
import {IngredientCard} from 'components/IngredientCard';
import validateResponse from 'helpers/validate-response';
import isError from 'helpers/isError';
import {IngredientProps} from './types';
import {
  RecipeIngredient,
  RecipeObject,
} from '../../../../../../api/recipe/types';
import {useFormikContext} from 'formik';

/**
 * The ingredient component.
 * @param {IngredientProps} props
 * @return {React.ReactElement<IngredientProps>}
 * @constructor
 */
function Ingredient(
    props: IngredientProps,
): React.ReactElement<IngredientProps> {
  const {values, setFieldValue} = useFormikContext<Partial<RecipeObject>>();
  const ingredients = values.ingredients || [];

  const [
    ingredient, setIngredient,
  ] = React.useState<IngredientObject | undefined>(
    undefined,
  );

  React.useEffect(() => {
    fetchIngredient(props.id);
  }, [props.index]);

  /**
   * Fetch the ingredient.
   * @param {IngredientObject["id"]} id
   */
  function fetchIngredient(id: IngredientObject['id']): void {
    getIngredientByID(id).then((response) => {
      validateResponse(response);

      if (response && !isError(response)) {
        setIngredient(response);
      }
    });
  }

  /**
   * The weight change event handler.
   * @param {RecipeIngredient["weight"]} weight
   */
  function handleWeightChange(weight: RecipeIngredient['weight']): void {
    setFieldValue(`ingredients[${props.index}].weight`, weight);
  }

  /**
   * The delete event handler.
   */
  function handleDelete(): void {
    setFieldValue('ingredients', [
      ...ingredients?.filter((_, index) => (
        index !== props.index
      ))
    ]);
  }

  return ingredient ? (
    <IngredientCard
      title={ingredient.title}
      energy={ingredient.energy}
      weight={props.weight || 0}
      onWeightChange={handleWeightChange}
      onDelete={handleDelete}
    />
  ) : <span>Loading...</span>;
}

export default React.memo(Ingredient);
